/**
 * @file 模型库详情页入口
 * @author FengGuang(fengguang01@baidu.com)
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import React from 'react';
import ReactDOM from 'react-dom';

import ModelBaseDetail from './ModelBaseDetail';

import './style/index.less';



ReactDOM.render(<ModelBaseDetail />, document.getElementById('root'));


